import { Pipe, PipeTransform } from '@angular/core';
import { CommentPluginService } from './comment-plugin.service';

@Pipe({
    name: 'commenttype',
    standalone: false
})
export class CommentTypePipe implements PipeTransform {
  public types: any;

  constructor(private service: CommentPluginService) {
    this.types = this.service.getTypes();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.types);
  }
}
